<template>
  <nav class="navbar is-link" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" href="#" style="" :to="{ path: '/instrumentos'}">
        <img style="max-height: 4rem;outline: none;" src="data:image/png;base64,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" border="0" class="logo-header" tabindex="0"/>
      </router-link>
      <div 
        class="navbar-item ajusta-tamanho"
        style="" 
        v-if="!emInstrumento && !instrumentState.isLanding">
        LISTA DE INSTRUMENTOS
      </div>


      <a v-if="!instrumentState.isLanding" style="/*height: 80px; width: 80px;*/" role="button" class="navbar-burger burger" v-bind:class="burgerActive ? 'is-active': ''" @click="burgerActive = !burgerActive" aria-label="menu" aria-expanded="false" data-target="navbar">

        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>

    </div>


    <div id="navbar" class="navbar-menu" v-bind:class="burgerActive || instrumentState.isLanding ? 'is-active': ''">
      <div class="navbar-end" @click="burgerActive = false" style="font-size: 0.9em">


        <div class="navbar-item" v-if="instrumentState.isLanding">
          <div class="navbar-item">
            <div class="buttons">
              <a id="acessar" class="button is-success is-fullwidth shake" @click="instrumentState.isLanding = false">
                {{textoBotaoAcessar}}
              </a>
            </div>
          </div>
        </div>


        <router-link
          v-if="emInstrumento && !instrumentState.isLanding"
          class="navbar-item"
          style="" 
          :to="{ path: '/instrumentos'}">
          INSTRUMENTOS
        </router-link>

        <router-link
          v-if="emInstrumento && !instrumentState.isLanding"
          class="navbar-item"
          style="" 
          :to="{ path: `/instrumento/${instId}/certificado`}"
          v-bind:class="rotaInst === 'certificado' ? 'is-active': ''">
          <span class="">
            CERTIFICADOS
            <!-- <span class="icon"><i class="fas fa-file"></i></span> -->
          </span>
        </router-link>

        <router-link
          v-if="emInstrumento && !instrumentState.isLanding && temCalibracaoComResultados"
          class="navbar-item"
          style="" 
          :to="{ path: `/instrumento/${instId}/analise`}"
          v-bind:class="(rotaInst === 'analise') ? 'is-disabled': ''">
          <span>
            <!-- <span class="icon"><i class="fas fa-chart-area"></i></span> -->
            ANÁLISE
          </span>
        </router-link>

        <div v-if="instrumentState.db && !instrumentState.isLanding" class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" style="">
            Outros
          </a>

          <div class="navbar-dropdown is-right" v-bind:class="!emInstrumento ? 'is-right' : ''">

            <a v-if="emInstrumento && instrumentState.usuarioTemAdminRole" class="navbar-item" @click="instrumentState.modals.configDialog = true">
              <span class="">
                <span class="icon"><i class="fas fa-cog"></i></span>
                Periodicidade e informações
              </span>
            </a>

            <a v-if="emInstrumento" class="navbar-item" @click="instrumentState.modals.ocorrenciasActive = true">
              <span class="">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                Ocorrências
              </span>
            </a>

            <a v-if="instrumentState.db && instrumentState.usuarioTemAdminRole" class="navbar-item" @click="instrumentState.modals.gerenciandoUsuarios = true">
              <span class="">
                <span class="icon"><i class="fas fa-users"></i></span>
                Usuários
              </span>
            </a>


            <a v-if="instrumentState.db && emInstrumento && instrumentState.data.inst && instrumentState.data.inst.type === 'instrumentoCliente' && instrumentState.usuarioTemAdminRole && instrumentState.usuarioGerencia" class="navbar-item" @click="instrumentState.modals.confirmarRemoverInstrumento = true">
              <span class="">
                <span class="icon"><i class="fas fa-minus-circle"></i></span>
                Remover Instrumento
              </span>
            </a>

            <a v-if="instrumentState.db &&
                      emInstrumento &&
                      instrumentState.data.inst &&
                      (instrumentState.data.inst._id.indexOf('cli-') === 0 || instrumentState.data.inst.type === 'instrumentoCliente') &&
                      instrumentState.usuarioTemAdminRole &&
                      instrumentState.usuarioGerencia"
            class="navbar-item" @click="alterarInstrumento">
              <span class="">
                <span class="icon"><i class="fas fa-edit"></i></span>
                Alterar Instrumento
              </span>
            </a>

            <a v-if="instrumentState.db && !emInstrumento && instrumentState.usuarioTemAdminRole && instrumentState.usuarioGerencia" class="navbar-item" @click="alterarInstrumento">
              <span class="">
                <span class="icon"><i class="fas fa-plus"></i></span>
                Novo Instrumento
              </span>
            </a>

            <hr v-if="instrumentState.usuarioTemAdminRole || emInstrumento" class="navbar-divider">
            <a v-if="instrumentState.db" class="navbar-item" @click="setLoggedOut">
              <span class="">
                <span class="icon"><i class="fas fa-sign-out-alt"></i></span>
                Sair
              </span>
            </a>
          </div>
        </div>

        <div v-if="instrumentoStatus" class="navbar-item">
          <div class="buttons">
            <a class="button" @click="instrumentState.modals.solicitarActive = true" v-bind:class="instrumentoStatus.cor">

              <span v-if="instrumentoStatus.situacao === 'CALIBRADO'" class="icon">
                <i class="fas fa-check-circle"></i>
              </span>

              <span v-if="instrumentoStatus.situacao !== 'CALIBRADO'" class="icon">
                <i class="fas fa-exclamation-triangle"></i>
              </span>

            </a>
          </div>
        </div>

      </div>


    </div>

    <!----------------------------------------------------------------
      Nav modals
    ------------------------------------------------------------------>

    <!-- #Novo Instrumento -->
    <div class="modal modal-fx-fadeInScale" v-if="true" v-bind:class="instrumentState.modals.novoInstrumento ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Novo Instrumento</h6>


              <div class="field">
                <label class="label has-text-weight-semibold">Descrição</label>
                <div class="control">
                  <input v-model="formNovoInstrumento.descricao" class="input" type="text" placeholder="Ex.: Multímetro digital" required>
                </div>
                <p v-if="formNovoInstrumento.descricao === ''" class="help is-danger">Você deve descrever o item</p>

              </div>

              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <label class="label has-text-weight-semibold">Modelo</label>
                      <input ref="inputModelo" list="modelList" v-model="formNovoInstrumento.modelo" class="input" type="text" placeholder=""/>
                    </div>
                    <p v-if="formNovoInstrumento.modelo === ''" class="help is-danger">Você deve informar qual é o modelo</p>
                  </div>
                  <div class="field">
                    <div class="control is-expanded">
                      <label class="label has-text-weight-semibold">Fabricante</label>
                      <input v-model="formNovoInstrumento.fabricante" class="input" type="text" placeholder="">
                    </div>
                    <p v-if="formNovoInstrumento.fabricante === ''" class="help is-danger">Você deve informar qual é o fabricante</p>
                    
                  </div>
                </div>

              </div>

              <div class="field is-horizontal">
                <div class="field-body">

                  <div class="field">
                    <label class="label">Identificação</label>
                    <div class="control">
                      <input v-model="formNovoInstrumento.identificacao" class="input" type="text" placeholder="">
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">Número de série</label>
                    <div class="control">
                      <input v-model="formNovoInstrumento.numeroserie" class="input" type="text" placeholder="">
                    </div>
                  </div>

                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-body">

                  <div class="field">
                    <label class="label">Patrimônio</label>
                    <div class="control">
                      <input v-model="formNovoInstrumento.patrimonio" class="input" type="text" placeholder="">
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">Orgão Calibrador</label>
                    <div class="control">
                      <input v-model="formNovoInstrumento.orgao" class="input" type="text" placeholder="">
                    </div>
                  </div>

                </div>
              </div>

              <br>

              <h6 class="title is-6">Calibrações</h6>
              <div class="media-content">
                <article class="media" v-for="(cal, i) in formNovoInstrumento.calibracoes">
                  <div class="media-left">
                    <p class="">
                      
                    </p>
                  </div>
                  <div class="content">
                    <div class="field">
                      <label class="label has-text-weight-semibold">Data da Calibração</label>
                      <div class="control">
                        <flat-pickr class="input" v-model="cal.HoraInicial" :config="instrumentState.flatpickrCfg"></flat-pickr>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label has-text-weight-semibold">Certificado</label>
                      <div class="control">
                        <input v-model="cal.Certificado" class="input" type="text" placeholder="">
                      </div>
                    </div>
                    <p v-if="cal.Certificado === ''" class="help is-danger">Informe o número do certificado</p>
                    
                    <div class="field is-grouped">
                      <div class="control">
                        <a v-if="formNovoInstrumento.calibracoes.length > 1" class="button is-danger is-small" @click="removeCalibracao(i)">
                          <span class="icon">
                            <i class="fas fa-minus-circle"></i>
                          </span><span>remover</span>
                        </a>
                      </div>

<!--                       <div class="file is-small">
                        <label class="file-label">
                          <input class="file-input" type="file" accept=".csv" @change="gravarCsv($event, cal)">
                          <span class="file-cta has-background-white">
                            <span class="file-icon">
                              <i class="fas fa-upload"></i>
                            </span>
                            <span class="file-label is-white">
                              Carregar dados (beta)
                            </span>
                          </span>
                        </label>
                      </div>
 -->                      
                    </div>


                    <p class="help is-danger"></p>

                    <a v-if="cal.Faixas && cal.Faixas.length" class="button is-small"
                      @click="calibracaoCsv(cal.Faixas, cal.Certificado)">
                      <span class="icon">
                        <i class="fas fa-download"></i>
                      </span><span>Baixar dados</span>
                    </a>

                  </div>
                </article>
              </div>

              <br>
              <div class="is-right">
                <p class="control">
                  <a class="button is-info is-small" @click="novaCalibracao">
                    <span class="icon">
                      <i class="fas fa-plus-circle"></i>
                    </span>
                    <span>nova calibração</span>
                  </a>
                </p>
              </div>
              <br>

              <div class="media-content">
                <article class="media">
                  <div class="content">
                    
                    <div class="field is-grouped">
                      <p class="control">
                        <a class="button" @click="instrumentState.modals.novoInstrumento = false">Cancelar</a>
                      </p>
                      <p class="control">
                        <a class="button is-link" v-bind:class="{'is-loading': gravandoNovoInstrumento}" :disabled="!novoInstrumentoValido" @click="novoInstrumento">Gravar</a>
                      </p>
                    </div>
                    <p v-if="!novoInstrumentoValido" class="help is-danger">Os campos em negrito devem ser preenchidos</p>
                  </div>
                </article>
              </div>


            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.novoInstrumento = false"></button>
    </div>
    <!-- /Novo Instrumento -->


    <!-- # Ocorrencias -->
    <div class="modal modal-fx-fadeInScale" v-if="instrumentoStatus" v-bind:class="instrumentState.modals.ocorrenciasActive ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box" style="font-size: 0.9em;">

          <h6 class="title is-6">Ocorrências</h6>

          <div class="field" v-if="instrumentState.usuarioTemAdminRole">
            <div class="control">
              <a class="button is-small" @click="novaOcorrenciaFormVisivel = !novaOcorrenciaFormVisivel">
              <span class="icon is-medium is-left">
                <i class="fas fa-plus"></i>
              </span>
              <span>Nova Ocorrência</span>
              </a>
            </div>
          </div>

          <div class="container is-fluid" style="margin-bottom: 12px;">
            <div v-if="novaOcorrenciaFormVisivel">
              <div class="field">
                <div class="control">
                  <textarea v-model="ocorrenciaDesc" class="textarea" placeholder="Descrição" autofocus=""></textarea>
                </div>
              </div>

              <div class="columns">

                <div class="column is-two-fifths">
                  <div class="field">
                    <label class="label">Categorias</label>
                    <div class="control">
                      <div class="select is-multiple is-small">
                        <select multiple size="4" v-model="categoriasSelecionadas">
                          <option value="Manutenção">Manutenção</option>
                          <option value="Defeito">Defeito</option>
                          <option value="Checagem Intermediária">Checagem Intermediária</option>
                          <option value="Ajuste">Ajuste</option>
                          <option value="Limpeza">Limpeza</option>
                          <option value="Outros">Outros</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-two-fifths">

                  <div v-if="ocorrenciaDeChecagemIntermediaria">
                    <div class="field">
                      <label class="label has-text-weight-semibold">Data da checagem</label>
                      <div class="control" style="max-width: 180px;">
                        <flat-pickr ref="dataDaChecagemEl" class="input" v-model="dataDaChecagem" :config="instrumentState.flatpickrCfgChecagem"></flat-pickr>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label has-text-weight-semibold">Data da próxima checagem</label>
                      <div class="control" style="max-width: 180px;">
                        <flat-pickr ref="dataDaProximaChecagemEl" class="input" v-model="dataDaProximaChecagem" :config="instrumentState.flatpickrCfgChecagem"></flat-pickr>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <button class="button is-small" @click="novaOcorrencia" :disabled="!permiteGravarOcorrencia">
               Gravar
              </button>

            </div>
          </div>

          
          <div class="timeline">
            <header class="timeline-header">
              <span class="tag is-primary">{{agora}}</span>
            </header>


            <span v-for="ocorr in confLog">
              <header v-if="ocorr.type === 'marcadorDeAno'" class="timeline-header">
                <span class="tag is-primary">{{ocorr.ano}}</span>
              </header>

              <div v-if="ocorr.type !== 'marcadorDeAno'" class="timeline-item">
                <span>
                  <div class="timeline-marker is-icon" v-bind:class="ocorr.icon === 'check' ? 'is-success' : ''">
                    <i class="fa" v-bind:class="'fa-'+ocorr.icon"></i>
                  </div>
                  
                  <div class="timeline-content">
                    <p class="heading">
                      {{ocorr.dataFmt}}
                      
                      <span class="icon" v-if="ocorr.id && instrumentState.usuarioTemAdminRole">
                        <a class="has-text-danger fas fa-times" @click="removerOcorrencia(ocorr.id)"></a>
                      </span>

                    </p>
                    <p v-if="ocorr.titulo" style="padding-bottom: 12px;" class="has-text-info">{{ocorr.titulo}}</p>
                    <div v-for="c in ocorr.alteracoes">
                      <code>{{c[0]}}</code> {{c[1]}} <code>{{c[2]}}</code> {{c[3]}} <code>{{c[4]}}</code>
                    </div>
                    <div v-for="c in ocorr.definicoes">
                      <code>{{c[0]}}</code> {{c[1]}} <code>{{c[2]}}</code>
                    </div>

                    <div v-if="ocorr.obs">{{ocorr.obs}}</div>
                    <div v-if="ocorr.categorias.length" v-for="categoria in ocorr.categorias" class="tag is-light">{{categoria}}</div>&nbsp;

                    <span v-if="statusChecagem && statusChecagem.id === ocorr.id" class="tag" v-bind:class="[statusChecagem.cor]">{{statusChecagem.texto}}</span>

                    <p class="has-text-link" style="font-size: 0.8em;padding-top: 12px;">{{ocorr.autor}}</p>
                  
                  </div>
                  
                </span>
              </div>
              
            </span>

          </div>

        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.ocorrenciasActive = false"></button>
    </div>
    <!-- / Ocorrencias -->



    <!-- #Solicitar orcamento -->
    <div class="modal modal-fx-fadeInScale" v-if="instrumentoStatus" v-bind:class="instrumentState.modals.solicitarActive ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Situação do Instrumento</h6>

              <span v-if="instrumentoStatus.situacao === 'CALIBRADO'" class="icon has-text-success">
                <i class="fas fa-check-circle"></i>
              </span>
              <span v-if="instrumentoStatus.situacao !== 'CALIBRADO'" class="icon has-text-warning">
                <i class="fas fa-exclamation-triangle"></i>
              </span>&nbsp; A calibração deste instrumento {{instrumentoStatus.texto}}.

              <p>Envie uma mensagem caso queira solicitar um orçamento:</p>

              <div class="field">
                <p class="control">
                  <textarea ref="solicMsg" class="textarea" placeholder="" :value="'Solicito orçamento para calibração do instrumento: ' + instrumentState.descItem + ', conforme certificado anterior número: ' + ultimoCertificado"></textarea>
                </p>
              </div>
              <nav class="level">
                <div class="level-left">
                  <div class="level-item">
                    <a class="button is-info" :class="enviandoMsg ? 'is-loading' : ''" @click="msgboxEnviaEmail">Enviar</a>
                  </div>
                </div>
              </nav>
            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.solicitarActive = false"></button>
    </div>
    <!-- /Solicitar orcamento -->

    <!-- #Usuarios -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.gerenciandoUsuarios ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" :class="processandoAcaoUsuarios ? 'is-loading' : ''">
        <div class="box">

          <form onsubmit="return false;">
            <div v-if="!gerenciandoUsuariosLogged">
              <h6>Confirme suas credenciais para continuar</h6>
              <div class="field">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="email" placeholder="Usuário" v-model="usersForm.username">
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <p class="control has-icons-left">
                  <input class="input" type="password" placeholder="Senha" v-model="usersForm.password">
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <p class="control">
                  <button class="button is-info is-small" @click="iniciaGestaoUsuarios" :class="processandoAcaoUsuarios ? 'is-loading' : ''">
                    Continuar
                  </button>
                </p>
              </div>
              
            </div>
          </form>

          <div v-if="gerenciandoUsuariosLogged">

            <div class="field">
              <p class="control">
                <a class="button is-info is-small" @click="instrumentState.modals.novoUsuarioDialog = true">
                  <span class="icon is-medium is-left">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Novo Usuário</span>
                </a>
              </p>
            </div>

            <table class="table">
              <thead>
                <tr>
                  <th>Usuário</th>
                  <th><abbr title="Administrador">Admin.</abbr></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in userList" class="row">
                  <td class="cell" data-title="Usuário">{{user.name}}</td>
                  <td class="cell" data-title="Admin.">
                    <div class="field" v-if="instrumentState.userCtx.name !== user.name">
                      <input type="checkbox" v-bind:user="user.name" name="switchEhAdmin" class="switch is-rounded" @click="mudaRole($event)" :checked="user.admin" :disabled="processandoAcaoUsuarios">
                      <label style="font-size: 10px;padding-top: 0.3rem;" @click="mudaRole($event)" for="switchEhAdmin"></label>
                      </label>
                    </div>
                  </td>
                  <td>
                  <button
                    v-if="instrumentState.userCtx.name !== user.name"
                    v-bind:user="user.name"
                    class="button is-danger is-small"
                    @click="removeUsuario($event)">Remover
                  </button>
                  </td>
                </tr>
              </tbody>
            </table>
            
          </div>

          
        </div>

      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.gerenciandoUsuarios = false"></button>
    </div>
    <!-- /Usuarios -->

    <!-- #Remover usuário -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.confirmarRemoverUsuario ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Atenção</h6>

          <p class="field">
            O usuário será removido. Tem certeza?
          </p>

          <div class="field is-grouped">
            <p class="control">
              <a class="button is-small" ref="removeUsuarioCancel">
                Cancelar
              </a>
            </p>
            <p class="control">
              <a class="button is-small is-link" ref="removeUsuarioOk" :class="processandoAcaoUsuarios ? 'is-loading' : ''">
                Confirmar
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <!-- /Remover usuário -->

    <!-- #Novo usuário -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.novoUsuarioDialog ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Novo Usuário</h6>

          <p class="field">
            Informa o e-mail do novo usuário
          </p>

          <div class="field">
            <div class="control">
              <input v-model="novoUsername" class="input" type="email" placeholder="e-mail" autofocus="">
            </div>
          </div>

          <div class="field is-grouped">
            <p class="control">
              <a class="button is-small" @click="instrumentState.modals.novoUsuarioDialog = false">
                Cancelar
              </a>
            </p>
            <p class="control">
              <a class="button is-small is-link" @click="novoUsuario()" :class="processandoAcaoUsuarios ? 'is-loading' : ''">
                Confirmar
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <!-- /Novo usuário -->

    <!-- #Config -->
    <div class="modal modal-fx-fadeInScale" v-if="instrumentState.data.inst" v-bind:class="instrumentState.modals.configDialog ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Periodicidade</h6>

          <div class="field">
            <label class="label">Status</label>
            <div class="control">
              <div class="select is-small">
                <select v-model="periodicidade.status">
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                  <option value="Apoio">Apoio</option>
                </select>
              </div>
            </div>
          </div>

          <div class="field is-horizontal has-addons">

            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    type="number"
                    max="120"
                    min="3"
                    v-model="periodicidade.val"
                    :disabled="periodicidade.status === 'Inativo' || periodicidade.status === 'Apoio'"
                  > <span class="label is-small">meses</span>
                </p>
                <br>
                <span class="icon">
                  <i class="fas fa-info-circle"></i>
                </span>Todos os instrumentos tem como padrão a periodicidade de 1 ano com alerta 2 meses antes do vencimento.
              </div>
            </div>

          </div>

          <br>
          <h6 class="title is-6">Informações</h6>
          <div class="field is-horizontal">
            <div class="field-body">

              <div class="field">
                <label class="label">Localização</label>
                <div class="control">
                  <input v-model="localizacao" class="input" type="text" placeholder="">
                </div>
              </div>

              <div class="field">
                <label class="label">Responsável</label>
                <div class="control">
                  <input v-model="tecnicoResponsavel" class="input" type="text" placeholder="">
                </div>
              </div>

            </div>
          </div>

          <div class="">
            <a class="button is-light" @click="periodicidade.val = instrumentState.configPeriodicidade.periodicidade.val;instrumentState.modals.configDialog = false">
              Cancelar
            </a>
            <a class="button is-link" @click="handleConfirmConfig">
              Confirmar
            </a>
          </div>

        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="periodicidade.val = instrumentState.configPeriodicidade.periodicidade.val;instrumentState.modals.configDialog = false"></button>
    </div>
    <!-- /Config -->

    <!-- #Remover Instrumento -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.confirmarRemoverInstrumento ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Atenção</h6>

          <p class="field">
            O Instrumento será removido. Tem certeza?
          </p>

          <div class="field is-grouped">
            <p class="control">
              <a class="button is-small" @click="instrumentState.modals.confirmarRemoverInstrumento = false">
                Cancelar
              </a>
            </p>
            <p class="control">
              <a class="button is-small is-link" :class="gravandoNovoInstrumento ? 'is-loading' : ''" @click="removerInstrumento">
                Confirmar
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <!-- /Remover Instrumento -->

    <!-- #Help Faixa -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.helpFaixa ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Faixa</h6>

              <div class="help-modal-content">
                <span>
                  <p>Este gráfico exibe os erros de calibração com suas respectivas barras de incerteza, em função dos pontos calibrados, do certificado de calibração e das regras de decisão correspondentes à data selecionada na opção <strong>Dados até</strong>, para a faixa selecionada.</p>
                  <p>Através da opção <strong>Resposta em frequência</strong>, os dados podem ser visualizados em função da frequência, quando possível.</p>
                  <p>Neste gráfico são visualizadas correções, quando aplicadas através do módulo <strong>Regras de Decisão</strong>.</p>
                </span>
              </div>
            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.helpFaixa = false"></button>
    </div>
    <!-- /Help Faixa -->

    <!-- #Help Tendencia -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.helpTendencia ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Tendência</h6>

              <div class="help-modal-content"><span><p>
              Este gráfico exibe os erros de calibração em função das datas de calibrações, para o ponto selecionado. A seleção do ponto é feita através do menu de seleção do ponto localizado logo acima do gráfico. <em>Neste gráfico não são visualizadas correções</em>,
              quando aplicadas através do módulo <strong>Regras de Decisão</strong>.
              </p></span></div>

            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.helpTendencia = false"></button>
    </div>
    <!-- /Help Tendencia -->

    <!-- #Help Regra -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.helpRegra ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Regras de Decisão</h6>

                <div class="help-modal-content">
                  <p>Este módulo permite a aplicação de correções e análises aos resultados de uma calibração, através da definição dos seguintes parâmetros:
                  </p> 
                  <p>
                    <strong>Corrigir</strong>: é efetuada uma correção (Erro = 0) aos dados da calibração. As equações resultantes dessa correção são disponibilizadas no módulo <strong>Fórmulas e Aplicação</strong>. A interpolação entre os pontos calibrados é feita linearmente.
                  </p> 

                  <p>
                    <strong>Fator</strong>: é selecionado um número inteiro que multiplicará o valor resultante do parâmetro 
                    <strong>Cálculo</strong>.
                  </p> 
                  <p>
                    <strong>EMA</strong>: é selecionado o limite que será exibido no gráfico da faixa, que será o mesmo utilizado na comparação para a Regra de Decisão. As opções para <strong>EMA</strong> são:
                  </p> 
                  <ul>
                    <li>
                      <strong>Certificado de Calibração</strong>: Erro Máximo Admissível especificado pelo fabricante que consta no Certificado de Calibração correspondente.
                    </li> 
                    <li>
                      <strong>Personalizado</strong>: valor definido pelo usuário.
                    </li>
                  </ul> 
                  <p>
                    A conformidade é definida de acordo com a <strong>Regra de Decisão</strong> e com os parâmetros ajustados pelo usuário. Os resultados são exibidos no módulo <strong>Dados e Resultados</strong>.
                  </p>

                  <p>As configurações deste módulo podem ser gravadas para posterior consulta através do botão 
                    <strong>Gravar configurações</strong>. Ao selecionar a opção 
                    <strong>Aplicar à todas as faixas</strong>, as configurações serão automaticamente estendidas e gravadas para todas as faixas do instrumento. Todas as alterações de parâmetros são registradas e podem ser consultadas no menu principal estendido, na opção <strong>Ocorrências</strong>.
                  </p>

                </div>


            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.helpRegra = false"></button>
    </div>
    <!-- /Help Regra -->

    <!-- #Help Formulas -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.helpFormulas ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Fórmulas e Aplicação</h6>

                <div class="help-modal-content"><span><p>Este módulo permite obter o valor correspondente à leitura do instrumento já com as configurações selecionadas no módulo <strong>Regras de Decisão</strong>. Para isso, basta digitar um valor no campo Indicação do instrumento, e a leitura com a análise e correção (quando habilitada) será mostrada logo abaixo.</p> <p>As equações resultantes das análises utilizadas, são disponibilizadas para o usuário. Essas equações estão formatadas para planilhas Excel, com possibilidade de seleção de célula de origem.</p></span></div>                

            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.helpFormulas = false"></button>
    </div>
    <!-- /Help Formulas -->

    <!-- #Help Dados -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.helpDados ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Dados e Resultados</h6>

              <div class="help-modal-content">
                <p>Este módulo apresenta os resultados mais relevantes ao usuário, para cada ponto calibrado. Também são mostrados os resultados de conformidade, de acordo com os parâmetros definidos no módulo <strong>Regras de Decisão.</strong></p>
              </div>

            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.helpDados = false"></button>
    </div>
    <!-- /Help Dados -->



  </nav>

</template>

<script>
import flatPickr from 'vue-flatpickr-component';
//import notebook from '@/components/Notebook.vue';
import pt from 'flatpickr/dist/l10n/pt.js';
import axios from 'axios'

flatpickr.localize(pt.pt);

import 'flatpickr/dist/flatpickr.css';
import moment from '../momentLocale'

import {fnSignformatter,
fnHideOnClickOutside,
fnRegreArray,
fnPegaDataUTCNum,
fnTextoEntreTags,
fnFmtData,
fnCampoValidoParaExibicao,
fnDescItem,
fnPegaStatus,
fnPegaStatusChecagem,
fnQueryInstIdData,
fnConfigPeriodicidade,
calDataToCsv,
calCsvToJSON,
CAMPOS,
fnSetLoggedOut} from '../fn'

import validaInstrumento from '../validaInstrumento.js'

const DADOS_INST_TEMPLATE = {
  _id: '',
  descricao: null,
  modelo: null,
  fabricante: null,
  identificacao: null,
  numeroserie: null,
  patrimonio: null,
  AlTipoPeriodo: 3, // meses
  AlPeriodoCalibracao: 12,
  empresa: 'Instrumento criado pelo cliente',
  localizacao: null,
  type: 'instrumentoCliente',
  calibracoes: [ {
      Certificado: null,
      CertificadoAl: null,
      HoraInicial: null,
      Faixas: undefined
    }]
}

export default {
  name: 'app-nav',
  props: [],
  components: {
    flatPickr,
    //notebook
  },
  watch : {
    'instrumentState.configPeriodicidade': {
      handler: function() {
        this.periodicidade.val = this.instrumentState.configPeriodicidade.periodicidade.val
        this.periodicidade.status = this.instrumentState.configPeriodicidade.periodicidade.status || 'Ativo'
        this.localizacao = this.instrumentState.configPeriodicidade.localizacao
        this.tecnicoResponsavel = this.instrumentState.configPeriodicidade.tecnicoResponsavel
      },
      deep: true
    },
    dataDaChecagem (data) {this.configuraDataInputChecagem()},
    ocorrenciaDeChecagemIntermediaria (val) {
      if (val) {this.configuraDataInputChecagem()};
    },
    listaModelos () {
      return
      /*
      var list = this.$refs.inputModeloDataList
      this.listaModelos.forEach(function(item){
         var option = document.createElement('option');
         option.value = item;
         list.appendChild(option);
      })*/

      //this.$refs.inputModelo.list = this.$refs.inputModeloDataList
      //this.$refs.inputModelo.setAttribute('list', 'modelList')
    }
  },
  data () {
    return {
      instrumentState: INSTRUMENT_STORE.state,
      //instrumentState.configPeriodicidade.periodicidade: 
      burgerActive: false,
      enviandoMsg: false,

      /* #Gestao de usuarios */
      usersForm: {
        username: '',
        password: ''
      },

      gerenciandoUsuariosLogged: false,
      processandoAcaoUsuarios: false,
      usuarioPodeGerirUsuarios: false,
      userList: [],
      novoUsername: '',
      /* /Gestao de usuarios */

      /* #Config */
      periodicidade: {
        val: null,
        status: 'Ativo'
      },
      localizacao: null, 
      tecnicoResponsavel: null,
      
      periodicidadeChecagem: null,
      alertaPeriodicidadeChecagem: false,
      //periodicidadeAnterior: {val: null}
      /* /Config */
      ocorrenciaDesc: '',
      categoriasSelecionadas: [],
      dataDaChecagem: null,
      dataDaProximaChecagem: null,

      gravandoOcorrencia: false,
      novaOcorrenciaFormVisivel: false,      
      formNovoInstrumento: JSON.parse(JSON.stringify(DADOS_INST_TEMPLATE)),
      gravandoNovoInstrumento: false
    }
  },
  mounted () {
  },
  methods: {
    setLoggedOut () {
      fnSetLoggedOut()
    },
    gravarCsv (el, cal) {
      let inputFile = el.target.files

      let containerEl = el.target.parentElement.parentElement
      let classIni = 'file is-small '
      let helpEl = containerEl.parentElement.querySelector('.help')
      let iconEl = containerEl.querySelector('.fas')

      //containerEl.classList = classIni
      //helpEl.innerText = ''
      //iconEl.classList = 'fas fa-refresh'
      window.setTimeout(() => {

        inputFile[0].text()
        .then((csv) => {

          let Faixas = calCsvToJSON(csv)
          let dummyInst = JSON.parse(JSON.stringify(this.formNovoInstrumento))
          
          dummyInst.calibracoes = [cal]
          for (var i = 0; i < dummyInst.calibracoes.length; i++) {
            let dummyCal = dummyInst.calibracoes[i]
            dummyCal.HoraInicial = moment(dummyCal.HoraInicial, 'DD/MM/YYYY').format(moment.defaultFormat)
            dummyInst.calibracoes[i] = dummyCal
          }
          //console.log(dummyInst)

          console.log(dummyInst)
          dummyInst.calibracoes[0].Faixas = Faixas
          'fabricante modelo identificacao numeroserie descricao patrimonio AlTipoPeriodo AlPeriodoCalibracao empresa'.split(' ').map(k=> dummyInst[k] = ' ')

          validaInstrumento(dummyInst, null, {roles:['{}__admin']})
          containerEl.classList = classIni+'is-success'
          iconEl.classList = 'fas fa-check'
          //helpEl.innerText = ''
          cal.Faixas = Faixas
          
        }).then((res) => {
          console.log(res)
        }).catch((err) => {
          iconEl.classList = 'fas fa-exclamation-triangle'
          containerEl.classList = classIni+'is-danger' 
          //helpEl.innerText = 'Erro ao processar arquivo: '+err.forbidden
          //err.forbidden
          console.log(err)
          cal.Faixas = undefined
        })
      }, 500)
      
    },
    calibracaoCsv (faixas, Certificado) {
      let calStr = calDataToCsv(faixas)
      let header = CAMPOS.reduce((a, c) => a+c+';' , '').trim()
      calStr = header+'\n'+calStr
      var dataStr = 'data:text/csv;charset=UTF-8,' + '\uFEFF' + encodeURIComponent(calStr);
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href",     dataStr);
      downloadAnchorNode.setAttribute("download", Certificado + ".csv");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
    configuraDataInputChecagem () {
      this.$nextTick(() => {  
        // desabilita datas anteriores a data de checagem
        var dataDaChecagem = this.$refs.dataDaChecagemEl.fp.selectedDates[0];
        this.$refs.dataDaProximaChecagemEl.fp.set('disable', 
          [function(date) {
              return (date < dataDaChecagem);
          }]
        );

        if (this.$refs.dataDaProximaChecagemEl.fp.selectedDates[0] < dataDaChecagem) {
          this.$refs.dataDaProximaChecagemEl.fp.setDate(dataDaChecagem)
        }
      })
    },
    novaCalibracao () {
      this.formNovoInstrumento.calibracoes.push(JSON.parse(JSON.stringify(DADOS_INST_TEMPLATE.calibracoes[0])))
    },
    removeCalibracao (i) {
      this.formNovoInstrumento.calibracoes.splice(i, 1)
    },
    removerOcorrencia (idOcorr) {
      let confirmar = confirm("Deseja remover esta ocorrência?");
      if (!confirmar) return
      this.instrumentState.db.get(idOcorr).then((doc) => {
        doc._deleted = true;
        return this.instrumentState.db.put(doc);
      }).then((result) => {
        this.$toasted.show('Ocorrência removida', {icon: 'fa-check-circle'})
      }).catch((err) => {
        this.$toasted.show('Erro ao remover Ocorrência', {icon: 'fa-exclamation-triangle'})
      });      
    },
    removerInstrumento () {
      this.instrumentState.db.get(this.instrumentState.data.inst._id).then((doc) => {
        doc._deleted = true;
        return this.instrumentState.db.put(doc);
      }).then((result) => {
        this.instrumentState.modals.confirmarRemoverInstrumento = false
        this.$router.push({ path: '/instrumentos' }).catch(err => {})
        this.$toasted.show('Instrumento Removido', {icon: 'fa-check-circle'})
      }).catch((err) => {
        console.log(err);
        this.$toasted.show('Erro ao remover Instrumento', {icon: 'fa-exclamation-triangle'})
      });
    },
    alterarInstrumento () {

      if (!this.emInstrumento) {
        this.formNovoInstrumento = JSON.parse(JSON.stringify(DADOS_INST_TEMPLATE))
        this.instrumentState.modals.novoInstrumento = true
        return
      }

      this.instrumentState.db.get(this.instrumentState.data.inst._id).then((doc) => {
        this.formNovoInstrumento = doc
        for (var i = 0; i < this.formNovoInstrumento.calibracoes.length; i++) {
          this.formNovoInstrumento.calibracoes[i].HoraInicial = moment(this.formNovoInstrumento.calibracoes[i].HoraInicial, moment.defaultFormat).format('DD/MM/YYYY')
        }
        this.instrumentState.modals.novoInstrumento = true
      }).catch((err) => {
        console.log(err);
        this.$toasted.show('Erro ao alterar o instrumento.', {icon: 'fa-exclamation-triangle'})
      });      
    },
    novoInstrumento () {
      if (!this.novoInstrumentoValido) return

      this.gravandoNovoInstrumento = true
      this.formNovoInstrumento._id = this.formNovoInstrumento._id || 'cli-'+~~(Date.now()/1000);

      var campos = ['modelo','fabricante','identificacao','numeroserie','patrimonio']
      campos.map((k) => {
        if (!this.formNovoInstrumento[k] || _.trim(this.formNovoInstrumento[k]).length === 0) {
          this.formNovoInstrumento[k] = ''
        }
      })

      for (var i = 0; i < this.formNovoInstrumento.calibracoes.length; i++) {
        this.formNovoInstrumento.calibracoes[i].HoraInicial = moment(this.formNovoInstrumento.calibracoes[i].HoraInicial, 'DD/MM/YYYY').format(moment.defaultFormat)
        this.formNovoInstrumento.calibracoes[i].CertificadoAl = this.formNovoInstrumento.calibracoes[i].Certificado
        this.formNovoInstrumento.calibracoes[i].Faixas = this.formNovoInstrumento.calibracoes[i].Faixas || []
      }

      this.formNovoInstrumento.calibracoes = _.reverse(_.sortBy(this.formNovoInstrumento.calibracoes, (item) => {
        return Date.UTC.apply(undefined, item.HoraInicial.split("T")[0].split("-"))
      }))

      this.instrumentState.db.put(this.formNovoInstrumento).then( (response) => {
        this.$toasted.show('Instrumento registrado.', {icon: 'fa-check-circle'})
        this.instrumentState.modals.novoInstrumento = false
        if (!this.emInstrumento) {
          this.$router.push({ path: '/instrumento/'+this.formNovoInstrumento._id }).catch(err => {})
        }
      }).catch( (err) => {
        console.log(err)
        this.$toasted.show('Não foi possível registrar o instrumento.', {icon: 'fa-exclamation-triangle'})
      }).finally( () => {
        this.gravandoNovoInstrumento = false
      })
    },
    novaOcorrencia () {
      this.gravandoOcorrencia = true

      var timestamp = Date.now()
      var ocorr = {
        _id: ''+this.instrumentState.data.inst._id+'_ocorr_'+timestamp,
        autor: this.instrumentState.userCtx['name'],
        timestamp: timestamp,
        desc: this.ocorrenciaDesc,
        categorias: this.categoriasSelecionadas
      }

      if (this.ocorrenciaDeChecagemIntermediaria) {
        ocorr.dataDaChecagem = moment(this.dataDaChecagem, 'DD/MM/YYYY').unix()*1000;
        ocorr.dataDaProximaChecagem = moment(this.dataDaProximaChecagem, 'DD/MM/YYYY').unix()*1000;
        ocorr.timestamp = ocorr.dataDaChecagem;
        ocorr.type = 'ocorr_'+this.instrumentState.data.inst._id;
      } else {
        ocorr.type = 'ocorr_'+this.instrumentState.data.inst._id;
      }

      this.instrumentState.db.put(ocorr).then( (response) => {
        this.$toasted.show('Ocorrência registrada.', {icon: 'fa-check-circle'})
        //limpa formulario de nova ocorrencia
        this.ocorrenciaDesc = ''
        this.categoriasSelecionadas = []
        this.novaOcorrenciaFormVisivel = false
      }).catch( (err) => {
        this.$toasted.show('Não foi possível registrar a ocorrencia.', {icon: 'fa-exclamation-triangle'})
      }).finally( () => {
        this.gravandoOcorrencia = false
        this.novaOcorrenciaFormVisivel = false
      })

    },
    msgboxEnviaEmail () {
      this.enviandoMsg = true
      var msg = '<p>'+this.$refs.solicMsg.value+'\n' +'</p>'+
      '<p>email: '+ localStorage.getItem('ms_username') +'</p>'+
      '<p>nome: '+ (localStorage.getItem('displayName') || 'sem nome informado') +'</p>'+
      '<p>empresa: '+ (this.instrumentState.data.inst.empresa || 'sem nome definido')+'</p>'

      axios({
        method: 'post',
        url: 'https://procal.ipt.br/couch_user_manager/call_after_challenge',
        timeout: 5000,
        data: {
          data: msg,
          doc_id: this.instrumentState.data.inst._id,
          rev: this.instrumentState.data.inst._rev,
          db_name: window.localStorage.getItem('nomedb')
        }
      })
      .then((response) => {
        this.$toasted.show('Mensagem enviada.', {icon: 'fa-check-circle'} )
      })
      .catch((error) => {
        console.log(error)
        this.$toasted.show('Erro ao enviar mensagem.', {icon: 'fa-exclamation-triangle'} )
      })
      .finally(() => {
        this.enviandoMsg = false
      })
    },
    pegaSessaoGestaoUsuarios () {
      var client = axios({
        method: 'get',
        url: 'https://procal.ipt.br/couch_user_manager/session',
        withCredentials: true
      })
      .then((response) => {
        this.usuarioPodeGerirUsuarios = response.data
        if (response.data) {
          this.pegaListaUsuarios()
          this.gerenciandoUsuariosLogged = true
        } else {

        }
        
      })
      .catch((error) => {
        console.log(error)
      })
    },
    iniciaGestaoUsuarios () {
      this.processandoAcaoUsuarios = true
      var client = axios({
        method: 'post',
        url: 'https://procal.ipt.br/couch_user_manager/session',
        timeout: 5000,
        withCredentials: true,
        data: {
          username: this.usersForm.username,
          password: this.usersForm.password,
          db_name: window.localStorage.getItem('nomedb')
        }
      })
      .then((response) => {
        this.pegaSessaoGestaoUsuarios()
        this.pegaListaUsuarios()
      })
      .catch((error) => {
        //console.log(error.code)
        if (error.code === 'ECONNABORTED') {
          this.$toasted.show('Não foi possível iniciar a gestão de usuários agora. Tente novamente em breve.', {icon: 'fa-exclamation-triangle'})
        } else {
          this.$toasted.show('Usuário ou senha inválido', {icon: 'fa-exclamation-triangle'})
        }
        this.processandoAcaoUsuarios = false
        this.pegaSessaoGestaoUsuarios()
      })
    },
    pegaListaUsuarios () {
      var client = axios({
        method: 'get',
        url: 'https://procal.ipt.br/couch_user_manager/list_users',
        withCredentials: true,
        params: {
          db_name: window.localStorage.getItem('nomedb'),
        }
      })
      .then((response) => {
        this.userList = response.data.map((item) => {
          var res = {}
          res['name'] = item['name']
          res['admin'] = 
            item.roles.indexOf(window.localStorage.getItem('nomedb')+'__admin') !== -1
          ;
          return res
        }).filter((item) => {
          return item.name !== window.localStorage.getItem('nomedb')+'-admin'
        })
        this.processandoAcaoUsuarios = false
      })
      .catch((error) => {
        console.log(error)
        this.processandoAcaoUsuarios = false
        this.usuarioPodeGerirUsuarios = false
        this.apagaSessao()
        //this.pegaSessaoGestaoUsuarios()
      })
    },
    removeUsuario ($event) {
      this.instrumentState.modals.confirmarRemoverUsuario = true

      var promise = new Promise((resolve, reject) => {
        var btnConfirm = this.$refs.removeUsuarioOk
        var btnReject = this.$refs.removeUsuarioCancel

        'click ontouchstart'.split(' ').map((e) => {
          btnConfirm.addEventListener(e, () => {resolve('ok')})
          btnReject.addEventListener(e, () => {reject('ko')})
        })

      })

      promise.then(() => {
        this.processandoAcaoUsuarios = true
        var client = axios({
          method: 'delete',
          url: 'https://procal.ipt.br/couch_user_manager/remove_user',
          withCredentials: true,
          timeout: 5000,
          data: {
            db_name: window.localStorage.getItem('nomedb'),
            user_name: $event.target.getAttribute('user')
          }
        })
        .then((_response) => {
          this.$toasted.show('Usuário removido', {icon: 'fa-check-circle'})
          this.pegaListaUsuarios()
        })
        .catch((error) => {
          this.$toasted.show('error', {icon: 'fa-exclamation-triangle'})
          this.processandoAcaoUsuarios = false
          this.pegaSessaoGestaoUsuarios()
        })
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.instrumentState.modals.confirmarRemoverUsuario = false
      })
    },
    novoUsuario () {
      //inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
      this.processandoAcaoUsuarios = true
      var client = axios({
        method: 'post',
        url: 'https://procal.ipt.br/couch_user_manager/create_user',
        withCredentials: true,
        data: {
          db_name: window.localStorage.getItem('nomedb'),
          new_user_name: this.novoUsername,
          roles: [window.localStorage.getItem('nomedb')+'__member'].toString() // Passar como string
        }
      }).then((_response) => {
        this.$toasted.show('Usuário ' + this.novoUsername + ' criado. Aguardando confirmação.', {icon: 'fa-check-circle'})
        this.pegaListaUsuarios()
      }).catch((error) => {
        this.$toasted.show('Erro ao criar novo usuário.', {icon: 'fa-exclamation-triangle'})
        console.log(error)
        this.processandoAcaoUsuarios = false
        this.pegaSessaoGestaoUsuarios()
      }).finally(() => {
        this.instrumentState.modals.novoUsuarioDialog = false
        this.novoUsername = ''
      })
    },
    mudaRole ($event) {
      this.processandoAcaoUsuarios = true
      var el = $event.target.parentElement.getElementsByTagName('input')[0]
      var user_name = el.getAttribute('user')
      var seraAdmin = !el.checked
      
      var userItem = this.userList.filter((item) => {return item.name === user_name})
      userItem[0].admin = !userItem[0].admin
      
      var client = axios({
        method: 'post',
        url: 'https://procal.ipt.br/couch_user_manager/update_roles',
        withCredentials: true,
        timeout: 5000,
        data: {
          db_name: window.localStorage.getItem('nomedb'),
          user_name_to_manage: user_name,
          roles: window.localStorage.getItem('nomedb') + (seraAdmin ? '__admin' :'__member')
        }
      })
      .then((_response) => {
        this.$toasted.show('Permissão alterada.', {icon: 'fa-check-circle'})
      })
      .catch((error) => {
        this.$toasted.show('Erro ao alterar usuário.', {icon: 'fa-exclamation-triangle'})
        console.log(error)
        this.pegaSessaoGestaoUsuarios()
      })
      .finally( () => {
        this.$nextTick(() => {
          this.pegaListaUsuarios()
        })
      })
    },
    novaConfig (data, cb) {
      var timestamp = Date.now()

      var conf = _.cloneDeep(data)
      conf['_id'] = ''+this.instrumentState.data.inst._id+'_config_'+timestamp
      conf['autor'] = this.instrumentState.userCtx['name']
      conf['timestamp'] = timestamp
      conf['type'] = 'config_'+this.instrumentState.data.inst._id
      
      this.instrumentState.db.put(conf)
        .then(cb)
        .catch( (err) => {
          this.$toasted.show('Erro ao gravar.', {icon: 'fa-exclamation-triangle'})
        console.log(err)
      }).finally( () => {
      })

    },
    handleConfirmConfig () {
      var config = {}
      config.periodicidade = {
        val: parseInt(this.periodicidade.val),
        suffixo: 'months',
        status: this.periodicidade.status
      }

      config.localizacao = this.localizacao
      config.tecnicoResponsavel = this.tecnicoResponsavel

      this.novaConfig(config, () => {
        this.$toasted.show('Periodicidade alterada.', {icon: 'fa-check-circle'})
      })

      this.instrumentState.modals.configDialog = false
    }

  },
  computed: {
    temUltimoCertificado () {
      return INSTRUMENT_STORE.state.temUltimoCertificado === true
    },    
    textoBotaoAcessar () {
      if (this.$route.query && this.$route.query.token) {
        return 'Definir senha'
      }
      return 'Acessar'
    },
    novoInstrumentoValido () {
      var campos = ['descricao','modelo','fabricante']
      for (var i = 0; i < campos.length; i++) {
        if (_.trim(this.formNovoInstrumento[campos[i]]).length === 0) {
          return false
        }
      }
      //if (!this.formNovoInstrumento.AlTipoPeriodo || !this.formNovoInstrumento.AlPeriodoCalibracao) {
      //  return false
      //}
            
      var calibracoes = this.formNovoInstrumento.calibracoes
      if (!this.formNovoInstrumento.calibracoes.length) {
        return false
      }

      var campos = ['Certificado', 'HoraInicial']

      for (var i = 0; i < calibracoes.length; i++) {
        for (var j = 0; j < campos.length; j++) {
          if (_.trim(calibracoes[i][campos[j]]).length === 0) {
            return false
          }
        }
      }
      

      return true
    },
    listaModelos () {
      return _.uniq(Object.keys(this.instrumentState.instrumentos).map((k) => this.instrumentState.instrumentos[k].item.modelo))
    },
    temCalibracaoComResultados () {
      return !!this.instrumentState.data.seriesDenormRes && this.instrumentState.data.seriesDenormRes.length
    },
    agora () {
      return moment().format('MMM YYYY')
    },
    confLog () {
      if (!this.instrumentState.data.ocorr || !this.instrumentState.data.config || !this.instrumentState.funcoes) return []
      
      // Extende objeto
      Object.keys(this.instrumentState.funcoes).map((k) => {
        window.T[k] = this.instrumentState.funcoes[k].desc
      })

      var res = []
        
      var itemAnterior = null
      var configSorted = this.instrumentState.data.config
      this.instrumentState.faixas.concat([{CodigoFaixaModelo: 'global', DescFaixa: 'Análise Global'}]).map((faixa) => {
        itemAnterior = null
        var codFaixa = faixa.CodigoFaixaModelo
        configSorted
          .filter((item) => item.analise && item.analise[codFaixa])
          .map((item) => {
            var dataMoment = moment(item.timestamp)
            var obj = {
              id: item._id,
              alteracoes: [],
              icon: 'sliders-h',
              obs: item.observacao,
              definicoes: [],
              categorias: [],
              autor: item.autor,
              data: item.timestamp,
              titulo: faixa.DescFaixa,
              ano: dataMoment.year(),
              dataFmt: dataMoment.format('DD/MM/YYYY')
              //timeDelta: moment.duration(Date.now()-item.timestamp).humanize()
            }
            var ana = item.analise[codFaixa]
            Object.keys(ana)
              .filter((k) => ['timestamp'].indexOf(k) === -1)
              .map((k) => {
                if (itemAnterior && itemAnterior[k] !== ana[k] && !_.isNil(itemAnterior[k]) && !_.isNil(ana[k])) {
                  obj.alteracoes.push(
                    [
                      window.T[k],
                      ' mudou de ',
                      window.T[itemAnterior[k]] || itemAnterior[k],
                      ' para ',
                      window.T[ana[k]] || ana[k]
                    ]
                  )
                }
                else if ( (!itemAnterior && !_.isNil(ana[k])) || (itemAnterior && _.isNil(itemAnterior[k]) && !_.isNil(ana[k]) && _.isNil(window.T[ana[k]])) ) {
                  obj.definicoes.push([window.T[k] || k, ' foi definido para ', window.T[ana[k]] || ana[k]])
                }
              })
            ;

            res.push(obj)
            itemAnterior = ana
          })
        ;


      })

      itemAnterior = {"periodicidade":{"val":12,"suffixo":"months","status":"Ativo"},"periodicidadeAlerta":{"val":2,"suffixo":"months"}}
      configSorted
        .filter((item) => item.periodicidade)
        .map((item) => {
          var dataMoment = moment(item.timestamp)
          var obj = {
            id: item._id,
            alteracoes: [], 
            icon: 'calendar-day',
            obs: null,
            definicoes: [],
            categorias: [],
            autor: item.autor,
            data: item.timestamp,
            titulo: null,
            ano: dataMoment.year(),
            dataFmt: dataMoment.format('DD/MM/YYYY')
            //timeDelta: moment.duration(Date.now()-item.timestamp).humanize()
          }
          if (itemAnterior && itemAnterior.periodicidade.val !== item.periodicidade.val) {
            var textoDataAnterior = ((itemAnterior ? itemAnterior.periodicidade.val : '12') + ' meses')
            obj.alteracoes.push(['Periodicidade', 'mudou de ', ''+textoDataAnterior, ' para ', item.periodicidade.val+' meses'])
          }

          if (itemAnterior && itemAnterior.periodicidade.status !== item.periodicidade.status && item.periodicidade.status) {
            obj.alteracoes.push(['Status', 'mudou de ', ''+(itemAnterior.periodicidade.status || 'Ativo'), ' para ', item.periodicidade.status])
          }

          if (obj.alteracoes.length) {
            res.push(obj)
          }

          itemAnterior = item
        })
      ;

      this.instrumentState.data.ocorr
        .map((item) => {
          var dataMoment = moment(item.timestamp)
          var obj = {
            id: item._id,
            alteracoes: [], 
            icon: item.dataDaProximaChecagem ? 'check-double' : 'edit',
            obs: item.desc,
            definicoes: [],
            categorias: item.categorias,
            autor: item.autor,
            data: item.timestamp,
            titulo: null,
            ano: dataMoment.year(),
            dataFmt: dataMoment.format('DD/MM/YYYY')
            //timeDelta: moment.duration(Date.now()-item.timestamp).humanize()
          }
          res.push(obj)
        })

      var calMap = {}
      for (var i = INSTRUMENT_STORE.state.queryData.length - 1; i >= 0; i--) {
        var item = INSTRUMENT_STORE.state.queryData[i]
        if (!calMap[item.Certificado] && !item.mock) {
          var dataMoment = moment(item.HoraInicial)
          var obj = {
            id: item.id,
            alteracoes: [], 
            icon: 'check',
            obs: 'Calibração executada. Certificado '+ item.Certificado,
            definicoes: [],
            categorias: [],
            autor: null,
            data: dataMoment.unix()*1000,
            titulo: null,
            ano: dataMoment.year(),
            dataFmt: dataMoment.format('DD/MM/YYYY')
            //timeDelta: moment.duration(Date.now()-item.timestamp).humanize()
          }

          res.push(obj)
          
          calMap[item.Certificado] = true
        }
      }

      var primeiroReg = INSTRUMENT_STORE.state.queryData[INSTRUMENT_STORE.state.queryData.length - 1]

      var primeiroRegMoment = moment(primeiroReg.HoraInicial)
      var agoraMoment = moment()
      
      var marcadoresDeAno = []
      for (var ano = primeiroRegMoment.year(); ano <= agoraMoment.year(); ano++) {
        marcadoresDeAno.push({type: 'marcadorDeAno', ano: ano, data: moment(''+ano+'-01-01T00:00:00-06:00').unix()*1000})
      }

      // Remove marcadores que não possuem dados no ano
      marcadoresDeAno.filter((item) => {
        return !!res.filter((resItem) => item.ano === resItem.ano).length
      })
      .map((item) => {
        res.push(item)
      })

      return _.reverse(_.sortBy(res, 'data'))
    },
    // periodicidadeVal () {
    //   if (this.instrumentState.configPeriodicidade) {
    //     return this.instrumentState.configPeriodicidade.periodicidade.val
    //   }
    // },
    instId () {
      return this.$route.params.id
    },
    emInstrumento () {
      return this.$route.path.split('/')[1] === 'instrumento'
    },
    rotaInst () {
      var res = this.$route.path.split('/')[3]
      if (this.emInstrumento && res === undefined) {
        return 'certificado'
      }
      return res
    },
    alertaInstrumento () {
      if (this.instId) {
        return this.instrumentState.instrumentos[''+this.instId]
      }
    },
    instrumentoStatus () {
      if (this.alertaInstrumento) {
        return this.alertaInstrumento.status
      }
    },
    ultimoCertificado () {
      if (!this.instrumentState.data.seriesDenormRes) {
        return '-'
      }

      if (!this.instrumentState.data.seriesDenormRes.length) {
        return '-'
      }

      var serie = this.instrumentState.data.seriesDenormRes.filter((item) => {
        return item.HoraInicial === this.alertaInstrumento.status.dataUltimaCal
      })[0]

      if (!serie) {
        return '-'
      }

      return serie['Certificado']
    },
    ocorrenciaDeChecagemIntermediaria () {
      return this.categoriasSelecionadas.indexOf('Checagem Intermediária') !== -1
    },
    permiteGravarOcorrencia () {
      if (this.ocorrenciaDeChecagemIntermediaria) {
        if (!!this.dataDaChecagem && !!this.dataDaProximaChecagem) {
          return true;
        }
        return false;
      }
      return this.categoriasSelecionadas.length > 0 || this.ocorrenciaDesc.length;
    },
    statusChecagem () {
      return fnPegaStatusChecagem(this.instrumentState.data.ocorr.filter((item) => item.dataDaProximaChecagem));
    }

  }

}
</script>

<style scoped>
</style>
